import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 31px;

  @media screen and (min-width: ${DESKTOP}px) {
    margin-bottom: 78px;
  }
`;
